import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromEmployeeMainReducer from '../employee-detail.reducer';
import { DeleteCustomerState, deleteCustomerFeatureKey } from '../reducers/delete-customer.reducer';
import * as deleteCustomerState from '../reducers/delete-customer.reducer';

//#region Employee detail ROOT STATE
export const getMainEmployeeState = createFeatureSelector<fromEmployeeMainReducer.State, DeleteCustomerState>(
  fromEmployeeMainReducer.employeeDetailFeatureKey
);
//#endregion

//#region Delete Customer SUB STATE
export const getDeleteCustomerState = createSelector(getMainEmployeeState, state => state[deleteCustomerFeatureKey]);
//#endregion

//#region Delete Customer SUB STATE
export const getDeleteCustomerRequest = createSelector(getDeleteCustomerState, deleteCustomerState.deleteCustomerRequestState);
export const getDeleteCustomerSuccess = createSelector(getDeleteCustomerState, deleteCustomerState.deleteCustomerResponse);
export const getDeleteCustomerFailure = createSelector(getDeleteCustomerState, deleteCustomerState.deleteCustomerFailureState);

export const getDeleteCustomerIsLoaded = createSelector(getDeleteCustomerState, deleteCustomerState.getDeleteCustomerIsLoaded);
//#endregion
